import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { EndFlowType, useEndFlowRedirect } from '../../../hooks/useEndFlowRedirect';
import { useBiLogger } from '../../../hooks/useBiLogger/useBiLogger';
import { gtmEvents } from '../../../utils/gtm';
import { useMsId } from '../../../store/appStore';
import { useSessionId } from '../../../hooks/useSessionId';
import { availableDomainAtom } from '../../domain/atoms';
import { COUPON_CODE_50_YEARLY } from '../../../consts';

interface UseUpgradePlanReturn {
  upgradePlan: () => Promise<void>;
  isLoading: boolean;
}

export const useUpgradePlan = (): UseUpgradePlanReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const availableDomain = useAtomValue(availableDomainAtom);
  const premiumUrl = useEndFlowRedirect(EndFlowType.PREMIUM, { domainName: availableDomain });
  const biLogger = useBiLogger();
  const metaSiteId = useMsId();
  const sessionId = useSessionId();

  const upgradePlan = async () => {
    try {
      setIsLoading(true);
      // Fire GTM event for checkout click
      gtmEvents.checkoutClick({
        metaSiteId,
        flow: 'ai-create-store',
        userId: sessionId,
        couponCode: COUPON_CODE_50_YEARLY,
      });
      biLogger.generateSite(premiumUrl);
      window.location.href = premiumUrl;
    } catch (error) {
      setIsLoading(false);
    }
  };

  return {
    upgradePlan,
    isLoading,
  };
};
